export interface LoginData {
  email: string
  password: string
}
export interface LoginResponse {
  bearer: string
  two_factor: boolean
}
export interface LocationState {
  redirectTo?: "string"
}

export interface IAccesses {
  groups: string[]
  modules: string[]
  services: string[]
}

export interface IUser {
  id: string
  name: string
  email: string
  username: string
  avatar?: string
  avatarThumb?: string
  permissions?: string[]
  roles?: { name: string }[]
  accesses?: IAccesses
}

export enum AuthChannel {
  Name = "__auth__",
  LoginEvent = "__auth--login__",
  LogoutEvent = "__auth--logout__",
}
